import { render, staticRenderFns } from "./SimpleExamModelForm.vue?vue&type=template&id=2d61f88d&"
import script from "./SimpleExamModelForm.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports